import ELID from 'constants/elid.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const ELEMENT_SELECTOR = Object.freeze(Object.fromEntries(Object.entries(ELID).map(([key, val]) => [key, `#${fromAnyToTrimmed(val)}`])));

// noinspection JSUnusedGlobalSymbols
export default ELEMENT_SELECTOR;
